import { render, staticRenderFns } from "./CodeBlock.vue?vue&type=template&id=38142f8c&scoped=true&"
import script from "./CodeBlock.vue?vue&type=script&lang=js&"
export * from "./CodeBlock.vue?vue&type=script&lang=js&"
import style0 from "./CodeBlock.vue?vue&type=style&index=0&id=38142f8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38142f8c",
  null
  
)

export default component.exports